// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab[data-v-4c25f62c] {\n  height: 0.58667rem;\n  font-weight: 400;\n  font-size: 0.42667rem;\n  text-align: center;\n  margin: 0.29333rem 0.58667rem;\n}\n.tab .block[data-v-4c25f62c] {\n  width: calc(100% - 0.53333rem);\n  height: 0.05333rem;\n  background: #f87a1b;\n  margin: 0.13333rem auto 0;\n}\n", ""]);
// Exports
module.exports = exports;
